<template>
  <div class="feed" ref="feed">
    <ul v-if="contact">
      <li
        v-for="message in messages"
        :class="`message${
          message.to == contact.depanneur_id ? ' sent' : ' received'
        }`"
        :key="message.id"
      >
        <div v-if="message.text != null" class="text">
          {{ message.text }}
        </div>

        <div class="image-container">
          <img
            v-if="message.image"
            :src="`${apiDomain}/uploads/files_chat/${message.image}`"
            width="20%"
            height="50%"
            alt=""
          />
        </div>
        <br />
        <i class="fa fa-clock-o"></i> {{ message.human_created_at }}

        <i
          v-if="message.read == 0"
          class="fa fa-check-circle"
          aria-hidden="true"
          style="font-size: 18px; color: grey"
        ></i>

        <img
          v-if="message.read == 1"
          class="rounded-circle"
          :src="`${apiDomain}/uploads/files_user/${contact.photo}`"
          style="width: 2%"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import EmojiPicker from "vue-emoji-picker";
import TimeAgo from "vue2-timeago";
import axios from "axios";
import { apiDomain } from "../../config";
export default {
  components: {
    TimeAgo,
    EmojiPicker,
  },
  props: {
    contact: {
      type: Object,
    },
    messages: {
      type: Array,
      required: true,
    },
    /*   */
  },

  data() {
    return {
      fixed: false,
      message: "",
      files: [],
      input: "",
      search: "",

      /* 

    
      
      ver2
      Z*/
      imageDataRio: "",
      textNull: null,
      imageNull: null,
      scrollPosition: null,
      text: "",
      from: this.$store.state.user.id,
      to: 79,
      nameContact: this.$store.state.user.nom,

      files: [],
      preview: null,
      image: null,
      preview_list: [],
      image_list: [],
      /* version 2 */
      apiDomain: "https://apil.auto-turki.com",

      LastMsg: [],
      list: [],
      drag: false,
      dragOptions: {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      },

      /* ver2 */
    };
  },

  created() {
    this.fetchLastMsg(this.$store.state.user.id);
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
  methods: {
    packPhoto: function (event) {
      var input = event.target;
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        var vm = this;
        reader.onload = function (e) {
          vm.pack.image = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
      console.log(input.files[0]);
    },
    send(e) {
      e.preventDefault();

      if (this.message == "") {
        return;
      }
      if (this.message.length < 1) {
        return;
        console.log("lng" + this.message.length);
      }

      this.$emit("send", this.message);
      this.message = "";
      /* 
      this.message = null;
      this.allMessages.push(response.data.message); */
    },
    append(emoji) {
      this.message += emoji;
    },
    updateScroll() {
      this.scrollPosition = window.scrollX;
    },
    submitMsg(e) {
      this.isCreatingAnn = true;
      let formData = new FormData();

      formData.append("from", this.from);
      formData.append("to", this.contact.depanneur_id);
      formData.append("image", this.$refs.image.files[0]);
      formData.append("nameContact", this.nameContact);

      /*  if (this.text == "") {
        formData.append("text", this.textNull);
        formData.append("image", this.$refs.image.files[0]);
      } else if (this.text != "") {
        formData.append("text", this.textNull);
        formData.append("image", this.imageNull);
      } */

      axios
        .post(
          `${apiDomain}/api/sendPrivateMessage2`,

          formData,
          {
            body: JSON.stringify(this.annonce),
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )

        .then((res) => {
          this.$noty.success("image  ajouter avec Succès ! ");
          this.isCreatingAnn = false;
          this.imageDataRio = "";
          // this.$router.push("/home/client/dashboard");
        })

        .catch((error) => {
          this.isCreatingAnn = false;
          //console.log(error.response.data);
          if (error.response && error.response.status == 422) {
            this.validationErrors = error.response.data.errors;
          }
        });
    },

    previewImageRio: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageDataRio = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    scrollToBottom() {
      setTimeout(() => {
        this.$refs.feed.scrollTop =
          this.$refs.feed.scrollHeight - this.$refs.feed.clientHeight;
      }, 50);
    },

    fetchLastMsg(id) {
      fetch(`${apiDomain}/api/showLatesMessage/${id}`)
        .then((res) => res.json())
        .then((res) => {
          this.LastMsg = res.latestMessage;
        })
        .catch((err) => console.log(err));
    },
  },
  sockets: {},
  watch: {
    contact(contact) {
      this.scrollToBottom();
    },
    messages(messages) {
      this.scrollToBottom();
    },
  },
};
</script>

<style lang="scss" scoped>
.nn {
  display: none;
}
.change_color {
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0 !important;
  left: 0px !important;
  z-index: 1030;
}

.custom-file-upload {
  // border: 1px solid #ccc;
  display: inline-block;
  //padding: 6px 12px;
  cursor: pointer;
}
.fixed-bottom {
  position: fixed;
  right: 60px;
  bottom: 0;
  top: 445px !important;
  left: 269px !important;
  //z-index: 1030;
}
.style_image {
  margin-top: -66px;
  margin-left: 76px;
}
.file-upload-form,
.image-preview {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: -6px;
}
img.preview {
  // width: 81px;
  width: 17px;
  height: 133px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
.feed {
  background: #f0f0f0;
  height: 100%;
  max-height: 470px;
  overflow: scroll;

  ul {
    list-style-type: none;
    padding: 5px;

    li {
      &.message {
        margin: 30px 0;
        width: 100%;

        .text {
          max-width: 800px;
          border-radius: 5px;
          padding: 12px;
          display: inline-block;
        }

        &.received {
          text-align: left;

          .text {
            background: rgb(255, 183, 68);
          }
        }

        &.sent {
          text-align: right;

          .text {
            background: #81c4f9;
          }
        }
      }
    }
  }
}
</style>

